var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarIconOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.175,
    height: 11.166,
    viewBox: "0 0 13.175 11.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_28",
    "data-name": "Union 28",
    d: "M6.882,10.874a1,1,0,0,1,0-1.41l3.88-3.88L6.892,1.7a1,1,0,0,1,1.4-1.42l4.59,4.59a1,1,0,0,1,0,1.41l-4.59,4.59a1,1,0,0,1-1.41,0Zm-6.59,0a1,1,0,0,1,0-1.41l3.88-3.88L.3,1.7A1,1,0,0,1,1.7.284l4.59,4.59a1,1,0,0,1,0,1.41L1.7,10.874a1,1,0,0,1-1.41,0Z",
    transform: "translate(0 0)",
    fill: "#1da193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconOpen);
export default __webpack_public_path__ + "static/media/sidebar_iconOpen.2e4a3b5b578435008ea4e458eee2aa0e.svg";
export { ForwardRef as ReactComponent };